var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["merchant:product:page:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-position": "right",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "酒店搜索：" } },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入预约人关键字",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSeachList($event)
                              },
                            },
                            model: {
                              value: _vm.keywords,
                              callback: function ($$v) {
                                _vm.keywords =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "keywords",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSeachList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": true,
                "highlight-current-row": "",
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "select-all": _vm.selectAll,
                select: _vm.selectOne,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm.checkedCities.includes("ID")
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", "min-width": "50" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("预约人")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: "预约人",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("房间编号")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "number",
                      label: "房间编号",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("预约入住日期")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "reservationStartDate",
                      label: "预约入住日期",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("预约离店日期")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "reservationEndDate",
                      label: "预约离店日期",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("预计到店时间")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "predictArrivalTime",
                      label: "预计到店时间",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("状态")
                ? _c("el-table-column", {
                    attrs: { label: "状态", "min-width": "80", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status == 0
                                ? _c("div", [_vm._v("未安排")])
                                : _vm._e(),
                              scope.row.status == 1
                                ? _c("div", [_vm._v("已入住")])
                                : _vm._e(),
                              scope.row.status == 2
                                ? _c("div", [_vm._v("已离店")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      348734515
                    ),
                  })
                : _vm._e(),
              _c(
                "el-table-column",
                {
                  attrs: { width: "190", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.tableFrom.type !==
                            _vm.ProductTypeEnum.InTheWarehouse &&
                          _vm.tableFrom.type !==
                            _vm.ProductTypeEnum.AlertInventory &&
                          _vm.tableFrom.type !==
                            _vm.ProductTypeEnum.PendingReview &&
                          _vm.checkPermi(["merchant:product:info"])
                            ? [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        path:
                                          "/product/list/creatProduct/" +
                                          scope.row.id +
                                          "/1/2/" +
                                          scope.row.type,
                                      },
                                    },
                                  },
                                  [_vm._v(" 详情 ")]
                                ),
                              ]
                            : _vm._e(),
                          _vm.checkPermi(["merchant:product:submit:audit"]) &&
                          _vm.tableFrom.type ===
                            _vm.ProductTypeEnum.PendingReview
                            ? [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePendingReview(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("提交审核")]
                                ),
                              ]
                            : _vm._e(),
                          _vm.tableFrom.type !== "5" &&
                          _vm.tableFrom.type !== "6" &&
                          _vm.checkPermi(["merchant:product:update"])
                            ? [
                                _vm.tableFrom.type !== "2" &&
                                _vm.tableFrom.type !== "4"
                                  ? _c("el-divider", {
                                      attrs: { direction: "vertical" },
                                    })
                                  : _vm._e(),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                              ]
                            : _vm._e(),
                          _vm.tableFrom.type === "5" &&
                          _vm.checkPermi(["merchant:product:restor"])
                            ? [
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRestore(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("恢复酒店")]
                                ),
                              ]
                            : _vm._e(),
                          (_vm.tableFrom.type === _vm.ProductTypeEnum.OnSale ||
                            (_vm.tableFrom.type ===
                              _vm.ProductTypeEnum.AlertInventory &&
                              scope.row.isShow) ||
                            (_vm.tableFrom.type ===
                              _vm.ProductTypeEnum.SoldOut &&
                              scope.row.isShow)) &&
                          _vm.checkPermi(["merchant:product:quick:stock:add"])
                            ? [
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row, true)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑库存")]
                                ),
                              ]
                            : _vm._e(),
                          (_vm.tableFrom.type ===
                            _vm.ProductTypeEnum.InTheWarehouse ||
                            (_vm.tableFrom.type ===
                              _vm.ProductTypeEnum.SoldOut &&
                              !scope.row.isShow) ||
                            (_vm.tableFrom.type ===
                              _vm.ProductTypeEnum.AlertInventory &&
                              !scope.row.isShow)) &&
                          _vm.checkPermi(["merchant:product:review:free:edit"])
                            ? [
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row, false)
                                      },
                                    },
                                  },
                                  [_vm._v("免审编辑")]
                                ),
                              ]
                            : _vm._e(),
                          (_vm.tableFrom.type === _vm.ProductTypeEnum.Audit ||
                            _vm.tableFrom.type ===
                              _vm.ProductTypeEnum.ReviewFailed ||
                            _vm.tableFrom.type ===
                              _vm.ProductTypeEnum.RecycleBin) &&
                          _vm.checkPermi(["merchant:product:delete"])
                            ? [
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(
                                          scope.row.id,
                                          _vm.tableFrom.type
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tableFrom.type === "5"
                                          ? "删除"
                                          : "加入回收站"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm.tableFrom.type ===
                          _vm.ProductTypeEnum.PendingReview
                            ? [
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: { size: "small", trigger: "click" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-dropdown-link" },
                                      [
                                        _vm._v(" 更多"),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _vm.checkPermi([
                                          "merchant:product:info",
                                        ])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                staticClass: "infoItem",
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleInfo(
                                                      scope.row.id,
                                                      scope.row.type
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("详情 ")]
                                            )
                                          : _vm._e(),
                                        _vm.checkPermi([
                                          "merchant:product:delete",
                                        ])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleDelete(
                                                      scope.row.id,
                                                      _vm.tableFrom.type
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tableFrom.type === "5"
                                                      ? "删除"
                                                      : "加入回收站"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm.tableFrom.type ===
                            _vm.ProductTypeEnum.InTheWarehouse ||
                          _vm.tableFrom.type ===
                            _vm.ProductTypeEnum.AlertInventory ||
                          (_vm.operation && !scope.row.isShow)
                            ? [
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: { size: "small", trigger: "click" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-dropdown-link" },
                                      [
                                        _vm._v(" 更多"),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        (_vm.tableFrom.type === "2" ||
                                          _vm.tableFrom.type === "4") &&
                                        _vm.checkPermi([
                                          "merchant:product:info",
                                        ])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                staticClass: "infoItem",
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleInfo(
                                                      scope.row.id,
                                                      scope.row.type
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("详情 ")]
                                            )
                                          : _vm._e(),
                                        _vm.checkPermi([
                                          "merchant:product:set:freight:template",
                                        ]) &&
                                        scope.row.type !== 5 &&
                                        scope.row.type !== 6
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleSetFreight(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("设置运费")]
                                            )
                                          : _vm._e(),
                                        _vm.checkPermi([
                                          "merchant:product:set:brokerage",
                                        ])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleSetCommission(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("设置佣金")]
                                            )
                                          : _vm._e(),
                                        _vm.checkPermi([
                                          "merchant:product:add:feedback:coupons",
                                        ])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleAddCoupon(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("添加回馈券")]
                                            )
                                          : _vm._e(),
                                        _vm.checkPermi([
                                          "merchant:product:delete",
                                        ])
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleDelete(
                                                      scope.row.id,
                                                      _vm.tableFrom.type
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tableFrom.type === "5"
                                                      ? "删除"
                                                      : "加入回收站"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("p", [
                      _c("span", { staticStyle: { "padding-right": "5px" } }, [
                        _vm._v("操作"),
                      ]),
                      _c("i", {
                        staticClass: "el-icon-setting",
                        on: { click: _vm.handleAddItem },
                      }),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.card_select_show,
                  expression: "card_select_show",
                },
              ],
              staticClass: "card_abs",
            },
            [
              [
                _c(
                  "div",
                  { staticClass: "cell_ht" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { indeterminate: _vm.isIndeterminate },
                        on: { change: _vm.handleCheckAllChange },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.checkSave()
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-checkbox-group",
                  {
                    on: { change: _vm.handleCheckedCitiesChange },
                    model: {
                      value: _vm.checkedCities,
                      callback: function ($$v) {
                        _vm.checkedCities = $$v
                      },
                      expression: "checkedCities",
                    },
                  },
                  _vm._l(_vm.columnData, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item,
                        staticClass: "check_cell",
                        attrs: { label: item },
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  1
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "showHeader",
          attrs: {
            title: !_vm.stockEdit ? "免审编辑" : "编辑库存",
            visible: _vm.drawer,
            direction: _vm.direction,
            size: 1500,
            "before-close": _vm.handleCloseEdit,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer && _vm.productId
            ? _c("store-edit", {
                attrs: {
                  productId: _vm.productId,
                  productType: _vm.productType,
                  stockEdit: _vm.stockEdit,
                  isSub: _vm.isSub,
                },
                on: { subSuccess: _vm.subSuccess },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-top",
          attrs: {
            visible: _vm.dialogVisible,
            title: "设置运费",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "75px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "运费模板：", prop: "tempId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "mr20",
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.formValidate.tempId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "tempId", $$v)
                        },
                        expression: "formValidate.tempId",
                      },
                    },
                    _vm._l(_vm.shippingTemplates, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "dialog-footer-inner" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btns",
                        attrs: { size: "small" },
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm.checkPermi(["merchant:product:update"])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "submission",
                            attrs: { type: "primary", loading: _vm.loadingBtn },
                            on: {
                              click: function ($event) {
                                return _vm.handleSubmit("formValidate")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogCommision
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "设置佣金",
                visible: _vm.dialogCommision,
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogCommision = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "commisionForm",
                  attrs: { model: _vm.commisionForm, rules: _vm.commisionRule },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "一级佣金比例：", prop: "extension_one" },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "priceBox",
                        attrs: {
                          step: 1,
                          "step-strictly": "",
                          min: 0,
                          max: 100,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.commisionForm.brokerage,
                          callback: function ($$v) {
                            _vm.$set(_vm.commisionForm, "brokerage", $$v)
                          },
                          expression: "commisionForm.brokerage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "二级佣金比例：", prop: "extension_two" },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "priceBox",
                        attrs: {
                          step: 1,
                          min: 0,
                          "step-strictly": "",
                          max: 100,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.commisionForm.brokerageTwo,
                          callback: function ($$v) {
                            _vm.$set(_vm.commisionForm, "brokerageTwo", $$v)
                          },
                          expression: "commisionForm.brokerageTwo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("span", [
                      _vm._v(
                        "备注：订单交易成功后给推广员返佣的比例，例:一级佣金比例设置5，则返订单金额的5%"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogCommision = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitCommisionForm("commisionForm")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("product-tpye", {
        ref: "productTpye",
        attrs: { addType: _vm.addType },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }